import ClientLayout from "../../components/Layout/ClientLayout";
import HeroComponent from "../../components/hero/HeroComponent";
import UpcomingEvents from "./UpcomingEvents";

import "./home.styles.scss";

import StatisticComponent from "../../components/banners/StatisticComponent";
import UpcomingPrograms from "./UpcomingPrograms";

import { BiWorld } from "react-icons/bi";
import { FaUserDoctor } from "react-icons/fa6";
import { FaHandsHelping, FaInstagram, FaExternalLinkAlt } from "react-icons/fa";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { useGetAdventuresQuery, useGetDestinationsQuery, useGetDestinationsWithImageQuery, useGetProgrammesQuery } from "../../apiCaller/apis/getApi";
import { GetTableListAPI } from "../../apiCaller/getAPIsCaller";
import Button, { BUTTON_TYPE_CLASSES } from "../../components/button/button.component";
import { useState } from "react";

const HomeComponent = () => {
  const [adventureSearch, setAdventureSearch] = useState({ totalItems: 4 });
  const {
    data: destinations,
    error: destinationError,
    isLoading: destinationIsLoading,
    isFetching: destinationIsFetching,
  } = GetTableListAPI({ isTraverse: false }, useGetDestinationsWithImageQuery);

    const {
      data: adventures,
      error: adventuresError,
      isLoading: adventuresIsLoading,
      isFetching: adventuresIsFetching,
    } = GetTableListAPI(adventureSearch, useGetAdventuresQuery);

    const {
      data: programmes,
      error: programmesError,
      isLoading: programmesIsLoading,
      isFetching: programmesIsFetching,
    } = GetTableListAPI({}, useGetProgrammesQuery);

     const handleSearch = (params) => {
       // console.log(params)
       const newSearch = { ...adventureSearch, ...params };
       setAdventureSearch(newSearch);
     }; 

     const handleWhatsapp = () => {
       const groupInviteLink =
         "https://chat.whatsapp.com/LiiuHHZpLQcBewqlGSEqF2";
       window.open(groupInviteLink, "_blank");
     };

     // Shop products data
     const shopProducts = [
       {
         id: 1,
         name: "Orok Hat",
         description: "Premium hiking hat for sun protection and style on the trails",
         instagramUrl: "https://www.instagram.com/p/DNkdK05t-ep/?igsh=MXUxbG8xNnIzdWRkMQ==",
         category: "Headwear",
         featured: true
       },
       {
         id: 2,
         name: "Virunga Backpack",
         description: "Durable hiking backpack designed for multi-day adventures",
         instagramUrl: "https://www.instagram.com/p/DNOVgaDtzyC/?igsh=MW5haGMyYWoyYTBicg==",
         category: "Bags",
         featured: true
       },
       {
         id: 3,
         name: "Kinangop Poles",
         description: "Lightweight trekking poles for stability and support",
         instagramUrl: "https://www.instagram.com/p/DOWJe8VjeB4/?igsh=MTMxbDFvOXFvajQ3Zg==",
         category: "Equipment",
         featured: false
       },
       {
         id: 4,
         name: "Iberg Bladder",
         description: "High-capacity hydration bladder for long hiking expeditions",
         instagramUrl: "https://www.instagram.com/p/DOITwEPjRV3/?igsh=ZGhuZzhwNHVrdWth",
         category: "Hydration",
         featured: false
       }
     ];

     const handleProductClick = (instagramUrl) => {
       window.open(instagramUrl, "_blank");
     };
  return (
    <ClientLayout>
      <div className="px-5">
        <HeroComponent destinations={destinations?.results} />
      </div>

      <div className="px-10 md:px-16 lg:px-48 py-10 w-full">
        <div>
          <UpcomingEvents adventures={adventures?.results} />
        </div>
      </div>

      {/* <div className="px-5">
        <StatisticComponent />
      </div> */}

      {/* Shop Products Section */}
      <div className="pt-24 pb-24 px-6 md:px-16 lg:px-32 bg-gradient-to-b from-gray-50 to-white">
        <div className="mx-16 md:mx-24 lg:mx-52">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center mb-4">
              <FaInstagram className="text-4xl text-pink-500 mr-3" />
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-color-primary-dark2">
                Shop with Us
              </h2>
            </div>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
              Gear up for your next adventure with our premium hiking equipment,
              designed by hikers for hikers
            </p>
            <div className="w-24 h-1 bg-color-primary-dark2 mx-auto mt-6"></div>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 xl:gap-12">
            {shopProducts.map((product, index) => (
              <div
                key={product.id}
                className={`group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 overflow-hidden cursor-pointer ${
                  product.featured
                    ? "lg:scale-105 border-2 border-color-primary-dark2"
                    : ""
                }`}
                onClick={() => handleProductClick(product.instagramUrl)}
                style={{
                  animationDelay: `${index * 100}ms`,
                  animation: "fadeInUp 0.6s ease-out forwards",
                }}
              >
                {/* Featured Badge */}
                {product.featured && (
                  <div className="absolute top-4 left-4 z-10">
                    <span className="bg-color-primary-dark2 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      Featured
                    </span>
                  </div>
                )}

                {/* Product Image Placeholder */}
                <div className="h-64 bg-gradient-to-br from-color-primary-dark2 to-color-primary-dark1 relative overflow-hidden">
                  <div className="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-10 transition-all duration-300"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-white text-center">
                      <div className="text-6xl mb-2 opacity-60">
                        {product.category === "Headwear" && "🎩"}
                        {product.category === "Bags" && "🎒"}
                        {product.category === "Equipment" && "🥾"}
                        {product.category === "Hydration" && "💧"}
                      </div>
                      <p className="text-sm opacity-80">{product.category}</p>
                    </div>
                  </div>

                  {/* Instagram overlay */}
                  <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <FaInstagram className="text-white text-2xl" />
                  </div>
                </div>

                {/* Product Info */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-color-primary-dark2 transition-colors duration-300">
                    {product.name}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                    {product.description}
                  </p>

                  {/* CTA Button */}
                  <div className="flex items-center justify-between">
                    <span className="text-color-primary-dark2 font-semibold text-sm">
                      {product.category}
                    </span>
                    <div className="flex items-center text-color-primary-dark2 group-hover:text-pink-500 transition-colors duration-300">
                      <span className="text-sm mr-2">View on</span>
                      <FaInstagram className="text-lg" />
                    </div>
                  </div>
                </div>

                {/* Bottom accent line */}
                <div className="h-1 bg-gradient-to-r from-color-primary-dark2 to-pink-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center mt-16">
            <div className="bg-white rounded-2xl shadow-lg p-8 max-w-2xl mx-auto border border-gray-100">
              <FaInstagram className="text-5xl text-pink-500 mx-auto mb-4" />
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                Follow us for more gear updates!
              </h3>
              <p className="text-gray-600 mb-6">
                Stay updated with our latest products, hiking tips, and
                adventure stories
              </p>
              <button
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/mambahikers_gear_shop?igsh=MThtc28xdGNuaWNqcw==",
                    "_blank"
                  )
                }
                className="bg-gradient-to-r from-pink-500 to-color-primary-dark2 text-white px-8 py-3 rounded-full font-semibold text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 inline-flex items-center"
              >
                <FaInstagram className="mr-2" />
                @mambahikers_gear_shop
                <FaExternalLinkAlt className="ml-2 text-sm" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="px-10 md:px-16 lg:px-48 py-5 lg:py-10 w-full mb-20">
        <div>
          <UpcomingPrograms programmes={programmes?.results} />
        </div>
      </div>

      <section className="relative bg-color-white2 mt-[-10rem] py-5 md:py-10  lg:py-24 px-10 md:px-16 lg:px-40 clip-path-polygon">
        <div className="w-full text-center p-8 lg:p-12">
          <h2>
            <span className="block text-4xl lg:text-7xl font-semibold text-color-primary-dark2 capitalize">
              Why Hike with Us
            </span>
            {/* <span className="block text-2xl md:text-3xl lg:text-4xl text-gray-500 capitalize my-5">
              to more places with affordable rates
            </span> */}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-20">
          <div className="text-center px-12 py-16 bg-white shadow-md rounded-lg">
            <i className="text-6xl lg:text-7xl text-color-primary-dark2 mb-4">
              <BiWorld />
            </i>
            <h3 className="text-3xl lg:text-5xl font-semibold mb-4">
              Hiking Programs
            </h3>
            <p className="text-gray-600 text-xl lg:text-2xl">
              We offer meticulously structured and progressive hiking programs,
              whether you are a beginner hiker or an avid hiker, there's
              something for everyone.
            </p>
          </div>

          <div className="text-center px-12 py-16 bg-white shadow-md rounded-lg">
            <i className="text-6xl lg:text-7xl text-color-primary-dark2 mb-4">
              <FaUserDoctor />
            </i>
            <h3 className="text-3xl lg:text-5xl font-semibold mb-4">
              Paramedic support
            </h3>
            <p className="text-gray-600 text-xl lg:text-2xl">
              At Mamba, your well-being is our priority. We provide trained
              paramedics on the trail, ensuring immediate medical assistance
              when needed. Whether it’s managing altitude effects, handling
              minor injuries, or offering expert emergency care, our paramedics
              allows you to focus on the adventure with confidence and peace of
              mind
            </p>
          </div>

          <div className="text-center px-12 py-16 bg-white shadow-md rounded-lg">
            <i className="text-6xl lg:text-7xl text-color-primary-dark2 mb-4">
              <FaHandsHelping />
            </i>
            <h3 className="text-3xl lg:text-5xl font-semibold mb-4">
              Experienced & professional guides
            </h3>
            <p className="text-gray-600 text-xl lg:text-2xl">
              Our team of experienced guides not only ensures your safety on the
              trail but also enhances your adventure with in-depth knowledge,
              local insights, and a passion for the great outdoors.
            </p>
          </div>

          <div className="text-center px-12 py-16 bg-white shadow-md rounded-lg">
            <i className="text-6xl lg:text-7xl text-color-primary-dark2 mb-4">
              <IoShieldCheckmarkOutline />
            </i>
            <h3 className="text-3xl lg:text-5xl font-semibold mb-4">
              Community
            </h3>
            <p className="text-gray-600 text-xl lg:text-2xl">
              Our network of fellow hikers provides a supportive environment,
              turning every expedition into a shared adventure where camaraderie
              and encouragement flourish
            </p>
          </div>
        </div>
      </section>

      {/* <section className="relative min-h-[30vh] bg-color-primary-dark1 opacity-70">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white px-8 w-[60vw] flex flex-col items-center">
          <p className="text-2xl font-bold">Find Your Path, Find Your People</p>
          <div className="mt-6"></div>
        </div>
      </section> */}
      <section className="relative min-h-[30vh]  lg:min-h-[35vh]  max-h-max bg-call-to-action bg-cover bg-bottom bg-fixed">
        <div className="absolute inset-0 bg-color-primary-dark1 opacity-50"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90vw] lg:w-[60vw] flex flex-col md:flex-row justify-between items-center text-white text-center p-12">
          <p className="text-[2.5rem] font-bold mb-6 md:mb-0 md:mr-6">
            Find Your Path, Find Your People
          </p>
          <div>
            <Button
              buttonType={BUTTON_TYPE_CLASSES.inverted}
              onClick={handleWhatsapp}
            >
              Join Our Community
            </Button>
          </div>
        </div>
      </section>

      {/* <section className="home__testimonials">
        <div className="bg-video">
          <video className="bg-video__content" autoPlay muted loop>
            <source src={bg_video} type="video/mp4" />
            Your Browser is not supported!
          </video>
        </div>
        <div className="header__secondary u-margin-bottom-small u-text-align-centre">
          <h2>
            <span className="header__secondary--main u-margin-bottom-medium">
              {" "}
              What Our Adventurers Are Saying{" "}
            </span>
          </h2>
        </div>
        <div className="home__testimonials-cards">
          <div class="story">
            <figure class="story__shape">
              <img src={hiker} alt="person on a tour" class="story__image" />
              <figcaption class="story__caption">Mary Smith</figcaption>
            </figure>
            <div class="story__text">
              <h3 class="heading-tertiary u-margin-bottom-small">
                I had the best week ever with my family
              </h3>
              <p>
                Lorem ipsum, Impedit dolorum nesciunt repellat architecto
                aspernatur Impedit dolorum nesciunt dolor sit amet consectetur
                adipisicing elit. Iure facilis aliquid magnam quas non sit
                corporis vero sed officiis quidem vel, architecto aut porro?
                Impedit dolorum nesciunt repellat architecto aspernatur.
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </ClientLayout>
  );
};

export default HomeComponent;
